import React from "react";

interface PoweredByModelsProps {}

const PoweredByModels: React.FC<PoweredByModelsProps> = () => (
  <>
    <h3 className="mt-4 text-sm opacity-80 font-inter text-center">Models Powered by</h3>
    <div className="flex items-center justify-center gap-6 mt-2 w-full">
      <img
        src="/ratl/ratl-model-logos.png"
        alt="Models Powered by"
        className="w-full max-w-xs sm:max-w-sm md:max-w-md object-contain h-auto mx-auto"
      />
    </div>
  </>
);

export default PoweredByModels;
